<template>
    <!-- <div>
        <button @click="prevPage">上一页</button>
        <button @click="nextPage">下一页</button>
        <div >{{ pageNumber }} / {{ totalNumber }}</div>
        <pdf
        :page="pageNum"
        :src="url"
        @progress="loadedRatio = $event"
        @num-pages="pageTotalNum=$event" 
        ></pdf>
  </div> -->
  <iframe :src="url" frameborder="0"></iframe>
</template>


<script>
import pdf from 'vue-pdf' 
export default {
    data() {
        return {
            url: '',
            pageNumber: 1,
            totalNumber: 1,
            loadedRatio: 0
        }
    },
    components: {
        pdf
    },
    created(){
        console.log(this.$route)

    },
    mounted() {
        
        this.getUrl()
    },
    methods: {
        getUrl(){
            const encodedUrl = this.$route.query.ws;
            this.url = decodeURIComponent(encodedUrl); // 解码 URL
            console.log(this.url,43)
            this.getNumPages()
        },
        getNumPages() {
        let loadingTask = pdf.createLoadingTask(this.url)
        loadingTask.promise.then(pdf => {
            this.totalNumber = pdf.numPages
        }).catch(err => {
            console.error('pdf 加载失败', err);
        })
        },
        // 上一页
        prevPage() {
        let page = this.pageNumber
        page = page > 1 ? page - 1 : this.totalNumber
        this.pageNumber = page
        },

        // 下一页
        nextPage() {
        let page = this.pageNumber
        page = page < this.totalNumber ? page + 1 : 1
        this.pageNumber = page
        }
    }
}
</script>


<style scoped>
iframe {
    width: 100vw;
    height: 100vh;
    margin: 0;
    padding: 0;
}
</style>